module.exports = __webpack_public_path__ + "a8e71a9823a1c923c244a14c5d3e662f.png";